//eslint-disable-next-line
import axios, { $asyncGet, $asyncPost } from '../common.js';

/**
 * 创建类别
 * v3/merchant/Mark/classify/create
 * @typedef {Object} ClassInfo
 * @property {string} class_no - 类别编号
 * @property {string} class_name - 类别名称
 * @property {string} standard_class_no - 系统类别编号
 */
export function onlinesClassifyCreate(v) {
  const data = {
    ...v,
    merchant_id: localStorage.getItem("merchant_id")
  }
  return $asyncPost("v3/merchant/Mark/classify/create", data);
}

/**
 * 获取所有线上类别
 * v3/merchant/Mark/classify/list
 */
export function onlinesGetClassifyList() {
  return $asyncGet(`v3/merchant/Mark/classify/list?merchant_id=${localStorage.getItem("merchant_id")}`);
}

/**
 * 更新线上类别信息
 * /v3/merchant/Mark/classify/update
 */
export function onlinesClassifyUpdate(v) {
  return $asyncPost(`v3/merchant/Mark/classify/update?class_no=${v.class_no.trim()}&merchant_id=${localStorage.getItem("merchant_id")}`, { ...v, url: "" });
}

/**
 * 删除线上类别
 * v3/merchant/Mark/classify/Delete
 * @param {string} class_no 类别编号
 * @returns
 */
export function onlinesClassifyDelete(class_no) {
  return $asyncPost(`v3/merchant/Mark/classify/Delete?class_no=${class_no.trim()}&merchant_id=${localStorage.getItem("merchant_id")}`);
}

/**
 * 创建sku
 * v3/merchant/Mark/sku/create
 */
export function onlinesSkuCreate(v) {
  return $asyncPost(`v3/merchant/Mark/sku/create`, v);
}

/**
 * 检索店铺定义的sku
 * v3/merchant/Mark/sku/list
 * @param {number} pageNo 页号
 * @param {number} pageSize 页大小
 */
export function onlinesSkuList(pageNo = 0, pageSize = 100) {
  return $asyncGet(`v3/merchant/Mark/sku/list?merchant_id=${localStorage.getItem("merchant_id")}&pageNo=${pageNo}&pageSize=${pageSize}`)
}

/**
 * 通过guid获取商品sku
 * v3/merchant/Mark/sku/query
 * @returns
 */
export function onlineSkuQuery(guid) {
  return $asyncGet(`v3/merchant/Mark/sku/query?merchant_id=${localStorage.getItem("merchant_id")}&guid=${guid}`)
}

/**
 * 修改店铺sku
 * v3/merchant/Mark/sku/update
 */
export function onlinesSkuUpdate(v) {
  return $asyncPost(`v3/merchant/Mark/sku/create?sku_code=${v.sku_code}`, v);
}

/**
 * 创建商品
 * v3/merchant/Mark/Goods/create
 */
export function onlinesGoodsCreatev(v) {
  return $asyncPost(`v3/merchant/Mark/Goods/create?merchant_id=${localStorage.getItem("merchant_id")}`, {
    ...v,
    merchant_id: localStorage.getItem("merchant_id")
  })
}
/**
 * 按页获取商品信息
 * v3/merchant/Mark/Goods/list
 * @param {number} pageNo 页号
 * @param {number} pageSize 页大小
 */
export function onlinesGoodsList(pageNo = 0, pageSize = 20) {
  return $asyncGet(`v3/merchant/Mark/Goods/list?merchant_id=${localStorage.getItem("merchant_id")}&pageNo=${pageNo}&pageSize=${pageSize}`);
}

/**
 * 修改商品信息
 * v3/merchant/Mark/Goods/update
 */
export function onlinesGoodsUpdate(v) {
  return $asyncPost(`v3/merchant/Mark/Goods/update`, v)
}

/**
 * 创建运费模板
 * /v3/merchant/Mark/shippingtemplate/create
 */
export function onlinesCreateShippingTemplate(v) {
  return $asyncPost(`v3/merchant/Mark/shippingtemplate/create?merchant_id=${localStorage.getItem("merchant_id")}`, v);
}

/**
 * 获取所有运费模板
 * @returns
 */
export function onlinesShippingtemplateList() {
  return $asyncGet(`v3/merchant/Mark/shippingtemplate/list?merchant_id=${localStorage.getItem("merchant_id")}`);
}

/**
 * 查询单个运费模板
 * @param {string|number} template_id - 运费模板ID
 * @returns {Promise} 返回运费模板详情
 */
export function onlinesShippingtemplateQuery(template_id) {
  return $asyncGet(`v3/merchant/Mark/shippingtemplate/query?template_id=${template_id}&merchant_id=${localStorage.getItem("merchant_id")}`);
}
/**
 * 修改运费模板
 * /v3/merchant/Mark/shippingtemplate/update
 */
export function onlinesShippingtemplateUpdate(v) {
  return $asyncPost(`v3/merchant/Mark/shippingtemplate/update?template_id=${v.template_id}&merchant_id=${localStorage.getItem("merchant_id")}`, v);
}

/**
 * 修改运费模板规则
 * /v3/merchant/Mark/shippingtemplate/update
 */
export function onlinesUpdateRule(v) {
  return $asyncPost(`v3/merchant/Mark/shippingtemplate/UpdateRule?template_id=${v.template_id}&merchant_id=${localStorage.getItem("merchant_id")}`, v.rule);
}

/**
 * 删除运费模板
 * @param {string} template_id
 * @returns
 */
export function onlinesDeleteShippingTemplate(template_id) {
  return $asyncPost(`v3/merchant/Mark/shippingtemplate/delete?template_id=${template_id}&merchant_id=${localStorage.getItem("merchant_id")}`);
}